<div class="circle">
  <span class="circle__content">{{ badgeData }}</span>
</div>
